import { useSupport } from "../../../context/support";

import { NavBadge } from "../style";

// Бейдж непрочитанных ответов поддержки (шапка / меню кабинета). Пустой, если непрочитанных нет.
const SupportUnreadBadge = ({ inline = false }) => {
  const { unread } = useSupport();

  if (!unread) return null;

  return <NavBadge $inline={inline}>{unread > 99 ? "99+" : unread}</NavBadge>;
};

export default SupportUnreadBadge;
